import api from "./api";

export const sendUsernameForForgotPassword = username => {
  return api().post("/password/forgot", { username });
};

export const resetPasswordRequest = data => {
  return api().post("/password/reset", data);
};
